export var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["EN"] = "EN";
    SupportedLanguages["LV"] = "LV";
    SupportedLanguages["RU"] = "RU";
})(SupportedLanguages || (SupportedLanguages = {}));
export var BookingSources;
(function (BookingSources) {
    BookingSources["THIRD_PARTY"] = "thirdParty";
    BookingSources["AIR_BALTIC"] = "airbaltic";
})(BookingSources || (BookingSources = {}));
export var RefundTypes;
(function (RefundTypes) {
    RefundTypes["GIFT_CARD"] = "giftCard";
    RefundTypes["MONEY"] = "money";
    RefundTypes["MONEY_VIA_AGENCY"] = "moneyViaAgency";
})(RefundTypes || (RefundTypes = {}));
export var RefundReasons;
(function (RefundReasons) {
    RefundReasons["IRREGULARITY"] = "irregularity";
    RefundReasons["VOLUNTARY"] = "voluntary";
})(RefundReasons || (RefundReasons = {}));
